// @ts-nocheck

import {UrlUtils} from "../../../main/index.js";
// import config from "../../../config.json" assert {type:"json"};

const urls = {
	how_to_use_ext: "https://TODO" // TODO
	// how_to_use_ext: config.urls.how_to_use_ext
};

UrlUtils.init(urls);

export default UrlUtils;
